import Summary from './Summary'

const PeopleEntry = () => {
  return <Summary type={'contact'} />
}

export default PeopleEntry
